module.exports = __webpack_public_path__ + "static/DSC_0055-1_Easy-Resize.com (1)-7bf61f0f27bb85bf7ac220f5d06e63c1.jpg";